export default __webpack_public_path__ + "static/media/filler.c906480a.png";